import React from "react";

function DotAlert({ number }) {
  return (
    <div
      className="absolute size-5 p-1  bg-secondary  -top-2 -right-2
  rounded-full text-xs text-white flex justify-center items-center"
    >
      {number}
    </div>
  );
}

export default DotAlert;
